import React, { useState, useEffect } from "react";
import { Tab } from "@headlessui/react";
import { Panel } from "./Panel";
import { Layout } from "./layout";
import { FormBuilder } from "./FormBuilder";
import { DefaultProps } from "./DefaultProps";
import { AppState } from "../../../../../stateManager/store";

// icons
import { ReactComponent as FormIcon } from "../../../../../assets/svg/solobuilder/add.svg";
import { ReactComponent as PropertiesIcon } from "../../../../../assets/svg/solobuilder/props.svg";
import { ReactComponent as LayoutIcon } from "../../../../../assets/svg/solobuilder/layout.svg";
import { ReactComponent as HelpIcon } from "../../../../../assets/svg/solobuilder/helpicon.svg";
import TableTemplates from "./tableTemplates/tableTempletes";
import TimeLineTemplates from "./timelineTemplates/timelineTemp"
import { useDispatch, useSelector } from "react-redux";
import { setStepIndex } from "../../../../../stateManager/store/onboarding/action";

export const FormProps: React.FC<any> = (props: any) => {
  const { isCheckedIn } = props
  const { isAssetInstanceSelected, assetEditModeEnabled, selectedElementId, ClickEvent } = useSelector((state: AppState) => {
    const formJson = state.formJson
    return {
      isAssetInstanceSelected: formJson.isAssetInstanceSelected,
      assetEditModeEnabled: formJson.assetEditMode.isEnabled,
      selectedElementId: formJson.selectedElementId,
      ClickEvent: formJson.ClickEvent
    }
  })
  const { guideVisible, info } = useSelector((state: AppState) => state.onboarding)

  const [bottomMenuVisibility, setBottomMenuVisibility] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTab2, setActiveTab2] = useState<any>(null);
  const [showTableTemplates, setShowTableTemplates] = useState(false);
  const [deviceType, setDeviceType] = useState("Sm")
  const [showTimelineTemplates, setShowTImelineTemplates] = useState(false);

  const dispatch = useDispatch()

  const panelStyle = {
    padding: "0px 8px 20px 8px"
  }

  // switch to `components list` tab, whenever
  // asset edit mode is turned on
  useEffect(() => {
    if (assetEditModeEnabled) {
      setActiveTab2(null)
      setBottomMenuVisibility(false)
    }
  }, [assetEditModeEnabled])
  useEffect(() => {
    if (selectedElementId) {
      if (activeTab != 1) {
        setActiveTab(1)
      }
    }
  }, [selectedElementId])
  useEffect(() => {
    setShowTableTemplates(false)
    if (activeTab === 0) {
      setBottomMenuVisibility(false);
      setActiveTab2(null);
    }
  }, [activeTab])

  useEffect(() => {
    if (!isCheckedIn) {
      setBottomMenuVisibility(false);
      setActiveTab2(null);
    }
  }, [isCheckedIn])



  const handleStepChange = () => {
    if (guideVisible) {
      dispatch(setStepIndex(info.stepIndex + 1))
    }
  }

  return (
    <>
      <div style={{ height: "100%", transition: "height 0.5s", maxHeight: '100%', paddingBottom: "15px" }}>
        <Tab.Group selectedIndex={activeTab} onChange={setActiveTab}>
          <Tab.List style={{ background: "rgba(34, 57, 121, 0.06)", height: "51px", alignItems: "center" }} className="flex justify-between p-6 h-18 border border-gray-100">
            <Tab onClick={handleStepChange} className="focus:outline-none tour_components_tab">
              <FormIcon height={17} width={17} title="Components" style={{ color: activeTab === 0 ? '#F1722E' : '#505F7B' }} />
            </Tab>
            <Tab className="focus:outline-none" data-test-id="properties_icon">
              <PropertiesIcon height={15} width={19} title="Properties" style={{ color: activeTab === 1 ? '#F1722E' : '#505F7B' }} />
            </Tab>
            <Tab className="focus:outline-none" data-test-id="layout_icon">
              <LayoutIcon height={15} width={14} title="Layout" style={{ color: activeTab === 2 ? '#F1722E' : '#505F7B' }} />
            </Tab>
            <Tab className="focus:outline-none" >
              <HelpIcon height={15} width={15} title="Help" style={{ color: activeTab === 3 ? '#F1722E' : '#505F7B' }}/>
            </Tab>
          </Tab.List>
          <Tab.Panels
            style={{ height: "calc(100% - 40px)", backgroundColor: "#FCFCFC" }}
            className={`overflow-auto`}
          >
            <Tab.Panel style={panelStyle} >
              <FormBuilder isCheckedIn={isCheckedIn} />
            </Tab.Panel>
            <Tab.Panel style={panelStyle}>
               {!showTableTemplates && !showTimelineTemplates && <DefaultProps isCheckedIn={isCheckedIn} />}
              {!isAssetInstanceSelected && !showTableTemplates && !showTimelineTemplates && <Panel setDeviceType={setDeviceType} setShowTemplates={setShowTableTemplates} setShowTimelineTemplate={setShowTImelineTemplates} isCheckedIn={isCheckedIn} section="properties"/>}
                {showTableTemplates && <TableTemplates setShowTableTemplates={setShowTableTemplates} /> }
                {showTimelineTemplates && <TimeLineTemplates deviceType={deviceType} setShowTableTemplates={setShowTImelineTemplates}/>}
            </Tab.Panel>
            <Tab.Panel style={panelStyle}>
              {!isAssetInstanceSelected && <Layout isCheckedIn={isCheckedIn} />}
            </Tab.Panel>
            <Tab.Panel>
              {/* <TreeView isCheckedIn={isCheckedIn} /> */}
              <div className="flex items-center justify-center py-4">
                <p>Help information will be shown here</p>
              </div>
            </Tab.Panel>
          </Tab.Panels>
        </Tab.Group>
      </div>
    </>
  );
};